import platform from 'platform'

function _fullOS() {
    return platform.os.family + ': ' + platform.os.version
}

export default {
    report () {
        return {
        name: platform.name, // 'Safari'
        version: platform.version, // '5.1'
        product: platform.product, // 'iPad'
        manufacturer: platform.manufacturer, // 'Apple'
        layout: platform.layout, // 'WebKit'
        os: _fullOS(), // 'iOS 5.0'
        description: platform.description, // 'Safari 5.1 on Apple iPad (iOS 5.0)'
        ua: platform.ua,
        devicePixelRatio: window.devicePixelRatio,
      }
    },
    fullOS () {
        return _fullOS()
    }
}